import { useLazyQuery, useQuery } from "@apollo/client";

import { LIST_OWN_OEM_EMAIL_TICKET_RULES_QUERY } from "#/src/api";
import type { EmailTicketRuleType } from "~/types/emailTicketRule";

export const useListEmailTicketRules = () => {
  const { data, loading, error } = useQuery<{
    listOwnOemEmailTicketRules: EmailTicketRuleType[];
  }>(LIST_OWN_OEM_EMAIL_TICKET_RULES_QUERY, {
    fetchPolicy: "cache-and-network",
  });

  return {
    rules: data?.listOwnOemEmailTicketRules ?? [],
    loading,
    error,
  };
};

/**
 * Counts the email rules that use a support ticket type, fetched fresh at the
 * moment of asking (e.g. right before deleting the type). Resolves to null when
 * the count could not be loaded.
 */
export const useCountEmailTicketRulesForType = () => {
  const [fetchRules] = useLazyQuery<{
    listOwnOemEmailTicketRules: EmailTicketRuleType[];
  }>(LIST_OWN_OEM_EMAIL_TICKET_RULES_QUERY, { fetchPolicy: "network-only" });

  return async (supportTicketTypeId: string): Promise<number | null> => {
    const { data, error } = await fetchRules();
    if (error || !data) return null;
    return data.listOwnOemEmailTicketRules.filter(
      (rule) => rule.supportTicketType?._id === supportTicketTypeId,
    ).length;
  };
};
